var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "claim-filter" }, [
    _c("h2", [_vm._v("Search Claims History")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-wrapper" },
      [
        _c("div", { staticClass: "form-group select-input" }, [
          _c(
            "label",
            { staticClass: "sr-only", attrs: { for: "claim-type" } },
            [_vm._v("Select an option")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.type,
                  expression: "type"
                }
              ],
              attrs: { id: "claim-type" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c(
                "option",
                { attrs: { value: "", selected: "", disabled: "" } },
                [_vm._v("Select an option")]
              ),
              _vm._v(" "),
              _c("option", { attrs: { value: "controlNumber" } }, [
                _vm._v("Control Number")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "PONumber" } }, [
                _vm._v("PO Number")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "LMCInvoiceNumber" } }, [
                _vm._v("LMC Invoice Number")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "LmcInvoiceDate" } }, [
                _vm._v("Invoice Date")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "VendorInvoiceNumber" } }, [
                _vm._v("Vendor Invoice Number")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "VendorName" } }, [
                _vm._v("Vendor Name")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "md-field",
          { staticClass: "input-group search-input-group" },
          [
            _c("md-input", {
              staticClass: "form-control search-input",
              attrs: {
                type: "search",
                id: "search-input",
                name: "searchtext",
                "aria-label": "Search News..."
              },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.addApiUrls()
                }
              },
              model: {
                value: _vm.searchText,
                callback: function($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText"
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-control-placeholder",
                attrs: { for: "search-input" }
              },
              [_vm._v("Search Term")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "input-group-btn search-submit" }, [
              _c("input", {
                staticClass: "icon-search submit-input",
                attrs: { type: "submit", value: "search" },
                on: {
                  click: function($event) {
                    return _vm.addApiUrls()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "clear-filter",
                attrs: { tabindex: "0" },
                on: {
                  click: function($event) {
                    return _vm.clearSearch()
                  }
                }
              },
              [_vm._v("clear all")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83be3716", { render: render, staticRenderFns: staticRenderFns })
  }
}